import { FieldPolicy, Reference } from '@apollo/client';

const findManyChannelMessage: FieldPolicy<Record<string, Reference>, Reference[]> = {
  keyArgs: ['where'],
  merge: (existing = {}, incoming, { readField }) => {
    // TODO: Improve this logic to merge based on input args and to
    // support two-way pagination (e.g. deeplinking to a specific message)
    const merged = { ...existing };
    incoming.forEach((item) => {
      const id = readField('id', item);
      if (typeof id === 'string') {
        merged[id] = item;
      }
    });
    return merged;
  },
  read: (existing) => {
    return existing && Object.values(existing);
  },
};

export default findManyChannelMessage;
